export default __webpack_public_path__ + "static/media/shield-icon.284f2e6a.svg";